import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "1",
    title: "Rentrips",
    menus: [
      { href: "/about", label: "Tentang kami" },
      // { href: "https://internship.rentrips.id/", label: "Karir" },
      { href: "/blog", label: "Blog" },
    ],
  },
  {
    id: "2",
    title: "Kontak",
    menus: [
      {
        href: "https://goo.gl/maps/AGeJTiiN19q85ucY9",
        label: "Balai Diklat Industri, Denpasar",
        targetBlank: true,
      },
      {
        href: "http://wa.me/6285161514605",
        label: "+62-851-6151-4605",
        targetBlank: true,
      },
      {
        href: "mailto:halo@rentrips.id",
        label: "halo@rentrips.id",
        targetBlank: true,
      },
      { href: "#", label: "Senin - Jumat, 09:00 - 17:00 WITA" },
    ],
  },
  {
    id: "3",
    title: "Pusat Bantuan",
    menus: [
      { href: "/snk", label: "Syarat dan Ketentuan" },
      { href: "/contact", label: "Layanan Konsumen" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
                target={item.targetBlank ? "_blank" : "_self"}
                rel="noreferrer"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-24 lg:py-32 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-3 lg:grid-cols-4 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
          <div className="col-span-2 flex items-center md:col-span-3">
            <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>
    </div>
  );
};

export default Footer;
